import { ReferenceOutcomeStatus } from '@/lib/apollo/model/outcome'

export const mapReferenceOutcomeStatus = (
  status: ReferenceOutcomeStatus | undefined | null,
): string => {
  if (!status) {
    return 'Awaiting'
  }

  switch (status) {
    case ReferenceOutcomeStatus.pass:
      return 'Pass'

    case ReferenceOutcomeStatus.fail:
    case ReferenceOutcomeStatus.awaitingReview:
      return 'Awaiting Review'

    case ReferenceOutcomeStatus.expired:
      return 'Expired'

    case ReferenceOutcomeStatus.pending:
      return 'Pending'

    default:
      return 'Awaiting'
  }
}
